module.exports = __webpack_public_path__ + "static/media/shopping-bag-edit.634cc964.svg";